module.exports = __webpack_public_path__ + "static/media/highlight-2.fd8457b2.png";